import { useLanguage } from "@/context/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const links = t.links;
  return (
    <footer className="bg-ink text-paper" data-testid="site-footer">
      <div className="px-5 md:px-10 py-12 md:py-16">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <p className="font-serif text-3xl tracking-tight">Jo Lenz</p>
            <p className="mt-3 font-mono text-[10px] uppercase tracking-[0.2em] text-paper/50 max-w-md leading-relaxed">
              {t.footer.line}
            </p>
          </div>
          <div className="flex flex-col gap-2 md:text-right">
            <a data-testid="footer-email-link" href={`mailto:${links.email}`} className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/80 link-underline w-fit md:self-end">
              {links.email}
            </a>
            <a data-testid="footer-art-link" href={links.artUrl} target="_blank" rel="noopener noreferrer" className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/80 link-underline w-fit md:self-end">
              jolenz.art ↗
            </a>
            {links.linkedinUrl && (
              <a data-testid="footer-linkedin-link" href={links.linkedinUrl} target="_blank" rel="noopener noreferrer" className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/80 link-underline w-fit md:self-end">
                LinkedIn ↗
              </a>
            )}
            {links.instagramUrl && (
              <a data-testid="footer-instagram-link" href={links.instagramUrl} target="_blank" rel="noopener noreferrer" className="font-mono text-[11px] uppercase tracking-[0.2em] text-paper/80 link-underline w-fit md:self-end">
                Instagram ↗
              </a>
            )}
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-paper/15 flex flex-wrap justify-between items-center gap-4">
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40">{t.footer.copyright}</span>
          <span className="flex gap-6">
            {t.footer.legal.map((l) => (
              <a
                key={l.label}
                data-testid={l.testid}
                href={l.url}
                target="_blank"
                rel="noopener noreferrer"
                className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/60 link-underline"
              >
                {l.label} ↗
              </a>
            ))}
          </span>
          <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-paper/40">{t.footer.madeNote}</span>
        </div>
      </div>
    </footer>
  );
};
